<template>
  <!-- 选择角色 - 移动端适配 -->
  <div class="chara-select-container">
    <!-- 顶部创建角色按钮 -->
    <div class="mobile-create-btn">
      <Button long size="large" @click="createName2()" type="primary">
        <Icon type="md-add" /> 创建角色
      </Button>
      <Button

          size="small"
          @click="selectCharaList"
        >
          <Icon type="ios-refresh" />刷新
        </Button>
    </div>
    <div v-if="!isMobile">
      <Row>
        <Col span="24">
          <Col span="12" v-for="(item, index) in charaLootsList" :key="index">
            <Card >
              <p slot="title" style="height: 24px">{{ item.name }} </p>
              <p slot="title" style="height: 24px">
<!--                <Button   size="small" @click="enroll(item.userId)">正式版</Button>-->
<!--                <Button   size="small" @click="enroll2(item.userId)">移动端</Button>-->
                <Button   size="small"  type="info" @click="enroll3(item.userId)">踏入世界</Button>
              </p>
              <p>{{ item.level }}</p>
            </Card>
          </Col>
        </Col>
        <br> <br>
        <Button type="error"  size="small" @click="createName()">创建角色</Button>
        <Button

          size="small"
          @click="selectCharaList"
        >
          <Icon type="ios-refresh" />刷新
        </Button>
        <!-- 创建角色 -->
        <Modal
          width="520"
          v-model="pasEject2"
          @on-ok="reg()"
          :styles="{ top: '80px' }"
          class-name="immortal-modal"
          :mask-closable="false"
        >
          <div slot="header" class="modal-header-custom">
            <div class="header-icon">🗡️</div>
            <div class="header-title">踏入仙途</div>
            <div class="header-subtitle">资质检测 · 道号登记</div>
          </div>

          <div class="create-character-content">
            <!-- 角色预览区 -->
            <div class="character-preview">
              <div class="avatar-circle" :class="formRegister.gender">
                <div class="avatar-inner">
                  {{ formRegister.gender === '1' ? '♂' : formRegister.gender === '2' ? '♀' : '?' }}
                </div>
                <div class="spirit-glow" v-if="formRegister.spiritRoot"></div>
              </div>
              <div class="preview-name" v-if="formRegister.name">{{ formRegister.name }}</div>
              <div class="preview-name placeholder" v-else>待赐道号</div>
              <div class="preview-root" v-if="formRegister.spiritRoot">
                {{ getSpiritRootLabel(formRegister.spiritRoot) }}灵根
              </div>
            </div>

            <!-- 表单区 -->
            <Form :model="formRegister" :label-width="0" class="immortal-form">
              <FormItem>
                <div class="input-group">
                  <label class="input-label">
                    <i class="icon-ming">名</i>
                    <span>道号</span>
                  </label>
                  <Input
                    v-model="formRegister.name"
                    placeholder="请输入道号（2-8个字符）"
                    :maxlength="8"
                    class="immortal-input"
                  >
                    <Icon type="ios-person" slot="prefix" />
                  </Input>
                  <div class="input-hint">好道号可凝聚气运，助益修行</div>
                </div>
              </FormItem>

              <FormItem>
                <div class="input-group">
                  <label class="input-label">
                    <i class="icon-ling">灵</i>
                    <span>灵根资质</span>
                  </label>
                  <Select
                    v-model="formRegister.spiritRoot"
                    placeholder="选择你的先天灵根"
                    class="immortal-select"
                  >
                    <Option
                      v-for="item in cityList"
                      :value="item.value"
                      :key="item.value"
                      :label="item.label"
                    >
                      <span class="root-option">
                        <span class="root-icon" :style="{ color: getRootColor(item.value) }">●</span>
                        {{ item.label }}灵根
                        <span class="root-desc">{{ getRootDesc(item.value) }}</span>
                      </span>
                    </Option>
                  </Select>
                  <div class="input-hint" v-if="formRegister.spiritRoot">
                    {{ getRootDetail(formRegister.spiritRoot) }}
                  </div>
                </div>
              </FormItem>

              <FormItem>
                <div class="input-group">
                  <label class="input-label">
                    <i class="icon-xing">性</i>
                    <span>性别</span>
                  </label>
                  <div class="gender-selector">
                    <div
                      class="gender-option"
                      :class="{ active: formRegister.gender === '1' }"
                      @click="formRegister.gender = '1'"
                    >
                      <div class="gender-icon male">♂</div>
                      <div class="gender-text">男修</div>
                      <div class="gender-desc">阳气充沛</div>
                    </div>
                    <div
                      class="gender-option"
                      :class="{ active: formRegister.gender === '2' }"
                      @click="formRegister.gender = '2'"
                    >
                      <div class="gender-icon female">♀</div>
                      <div class="gender-text">女修</div>
                      <div class="gender-desc">阴元纯净</div>
                    </div>
                  </div>
                </div>
              </FormItem>

              <FormItem>
                <div class="input-group">
                  <label class="input-label">
                    <i class="icon-xing">像</i>
                    <span>头像</span>
                  </label>
                  <div class="face-selector">
                    <div
                      v-for="item in charaFaceList"
                      :key="'pc-face-' + item.id"
                      class="face-option"
                      :class="{ active: formRegister.face === item.url }"
                      @click="formRegister.face = item.url"
                    >
                      <img :src="item.url" :alt="'face-' + item.id" class="face-option-img" />
                    </div>
                  </div>
                </div>
              </FormItem>
            </Form>
          </div>

          <div slot="footer" class="modal-footer-custom">
            <Button
              type="default"
              @click="pasEject2 = false"
              class="btn-cancel"
            >暂离</Button>
            <Button
              type="primary"
              @click="reg()"
              :disabled="!canSubmit"
              :loading="isSubmitting"
              class="btn-confirm"
            >
              <span v-if="!isSubmitting">确认入世</span>
              <span v-else>测算天机中...</span>
            </Button>
          </div>
        </Modal>
          </Row>
    </div>
    <div v-if="isMobile">
    <!-- 角色列表 - 网格布局 -->
      <div class="chara-grid">
      <div
        v-for="(item, index) in charaLootsList"
        :key="index"
        class="chara-card"
        :class="{'selected': selectedCharaId === item.userId}"
      >
        <div class="chara-card-content">

          <!-- 角色信息 -->
          <div class="chara-info">
            <div class="chara-name">{{ item.name }}</div>
            <div class="chara-level">Lv.{{ item.level }}</div>
          </div>

          <!-- 选择按钮 -->
          <div class="chara-actions">
            <ButtonGroup >
<!--              <Button @click="enroll(item.userId)" type="info"   style="width: 30%" ghost>
                正式版
              </Button>-->
<!--              <Button @click="enroll2(item.userId)" type="warning"    style="width: 30%" ghost>
                移动端
              </Button>-->
              <Button @click="enroll3(item.userId)" type="info"  style="width: 90%;" >
                踏入世界
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>

      <!-- 空状态提示 -->
      <div v-if="charaLootsList.length === 0" class="empty-chara-list">
        <Icon type="ios-people" size="48" color="#ccc" />
        <p>暂无角色</p>
        <p class="empty-tip">点击上方按钮创建第一个角色</p>
      </div>
    </div>
    </div>

    <!-- 创建角色模态框 -->
    <Modal
      v-model="pasEject"
      title="创建角色"
      :fullscreen="isMobile"
      :footer-hide="!isMobile"
      class-name="create-chara-modal"
    >
      <div class="create-chara-content">
        <Form :model="formRegister" label-position="top">
          <FormItem label="道号">
            <Input
              v-model="formRegister.name"
              placeholder="请输入道号（2-10个字符）"
              size="large"
              :maxlength="10"
            />
          </FormItem>

          <FormItem label="选择灵根">
            <Select
              v-model="formRegister.spiritRoot"
              size="large"
              placeholder="选择初始灵根属性"
            >
              <Option
                v-for="item in cityList"
                :value="item.value"
                :key="item.value"
              >
                <div class="spirit-option">
                  <span class="spirit-name">{{ item.label }}</span>
                  <span class="spirit-desc">{{ getSpiritDesc(item.value) }}</span>
                </div>
              </Option>
            </Select>
          </FormItem>
          <FormItem>
                <div class="input-group">
                  <label class="input-label">
                    <i class="icon-xing">性</i>
                    <span>性别</span>
                  </label>
                  <div class="gender-selector">
                    <div
                      class="gender-option"
                      :class="{ active: formRegister.gender === '1' }"
                      @click="formRegister.gender = '1'"
                    >
                      <div class="gender-icon male">♂</div>
                      <div class="gender-text">男修</div>
                      <div class="gender-desc">阳气充沛</div>
                    </div>
                    <div
                      class="gender-option"
                      :class="{ active: formRegister.gender === '2' }"
                      @click="formRegister.gender = '2'"
                    >
                      <div class="gender-icon female">♀</div>
                      <div class="gender-text">女修</div>
                      <div class="gender-desc">阴元纯净</div>
                    </div>
                  </div>
                </div>
              </FormItem>
          <FormItem label="选择头像">
            <div class="face-selector">
              <div
                v-for="item in charaFaceList"
                :key="'mobile-face-' + item.id"
                class="face-option"
                :class="{ active: formRegister.face === item.url }"
                @click="formRegister.face = item.url"
              >
                <img :src="item.url" :alt="'face-' + item.id" class="face-option-img" />
              </div>
            </div>
          </FormItem>          <!-- 移动端底部按钮 -->
          <div v-if="isMobile" class="mobile-modal-buttons">
            <Button
              @click="reg()"
              type="primary"
              shape="circle"
              long
              size="large"
              :disabled="!formRegister.name || !formRegister.spiritRoot"
            >
              创建角色
            </Button>
            <Button
              @click="pasEject = false"
              type="default"
              long
              size="large"
              style="margin-top: 10px"
            >
              取消
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  </div>
</template>
        <script>
        export default {
            name: "selectChara",
            data() {
                return {
                  isMobile: false,
                  selectedCharaId: null,
                   charaLootsList: [],
                   isSubmitting: false,
                   user: {}, // 用户的全部消息
                   pasEject:false,
                   pasEject2:false,
                    formRegister: {
                      name: '',
                      spiritRoot: '',
                      userId: undefined,
                      gender: '',
                      face: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/1.png',
                    },
                    charaFaceList: [
                      { id: 1, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/1.png' },
                      { id: 2, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/2.png' },
                      { id: 3, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/3.png' },
                      { id: 4, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/4.png' },
                      { id: 5, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/5.png' },
                      { id: 6, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/6.png' },
                      { id: 7, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/7.png' },
                      { id: 8, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/8.png' },
                      { id: 9, url: 'http://1.15.75.55/foodie-api/foodie/faces/charaIcon/9.png' },
                    ],
                    cityList: [
                      { value: '1', label: '金', desc: '杀伐果断，剑修首选' },
                      { value: '2', label: '木', desc: '生机盎然，丹道亲和' },
                      { value: '3', label: '水', desc: '柔韧绵长，术法精通' },
                      { value: '4', label: '火', desc: '爆裂炽热，炼器炼丹' },
                      { value: '5', label: '土', desc: '厚重沉稳，防御无双' },
                      { value: '6', label: '风', desc: '迅捷飘逸，身法灵动' },
                      { value: '7', label: '雷', desc: '天威浩荡，破坏极致' },
                      { value: '8', label: '冰', desc: '寒霜刺骨，控制无双' }
                    ]
                };
            },
            created() {
                if(this.charaLootsList.length<1){
                  this.selectCharaList();
                }
            },
            mounted() {
              this.checkMobile();
              window.addEventListener('resize', this.checkMobile);
            },
            beforeDestroy() {
              window.removeEventListener('resize', this.checkMobile);
            },
            computed: {
              canSubmit() {
                return this.formRegister.name &&
                      this.formRegister.name.length >= 2 &&
                      this.formRegister.spiritRoot &&
                      this.formRegister.gender
              }
            },
            methods: {
              checkMobile() {
                const responsive = this.$store && this.$store.state && this.$store.state.responsive
                  ? this.$store.state.responsive
                  : null
                this.isMobile = responsive ? !!responsive.isMobile : window.innerWidth <= 768
                //this.selectCharaList();
              },
              getSpiritRootLabel(value) {
                const item = this.cityList.find(i => i.value === value)
                return item ? item.label : ''
              },
              getRootColor(value) {
                const colors = {
                  gold: '#FFD700',
                  wood: '#228B22',
                  water: '#1E90FF',
                  fire: '#FF4500',
                  earth: '#8B4513',
                  wind: '#00CED1',
                  thunder: '#9400D3',
                  ice: '#87CEEB'
                }
                return colors[value] || '#999'
              },
              getRootDesc(value) {
                const item = this.cityList.find(i => i.value === value)
                return item ? item.desc : ''
              },
              getRootDetail(value) {
                const details = {
                  gold: '金灵根者，主杀伐，剑气纵横三万里',
                  wood: '木灵根者，主生机，丹道医术皆精通',
                  water: '水灵根者，主变化，术法绵绵无绝期',
                  fire: '火灵根者，主爆裂，炼丹炼器两相宜',
                  earth: '土灵根者，主厚重，防御无双立不败之地',
                  wind: '风灵根者，主速度，身法飘逸难捉摸',
                  thunder: '雷灵根者，主天威，破坏力举世无双',
                  ice: '冰灵根者，主控制，寒霜所至万物寂'
                }
                return details[value] || ''
              },
              getSpiritDesc(value) {
                const descMap = {
                  '1': '主攻击，金属性',
                  '2': '主生命，木属性',
                  '3': '主法力，水属性',
                  '4': '主暴击，火属性',
                  '5': '主防御，土属性',
                  '6': '主速度，风属性',
                  '7': '主穿透，雷属性',
                  '8': '主控制，冰属性'
                };
                return descMap[value] || '';
              },
                distinguishColor(color) {
                    if (color == 1) {
                        return "#000";
                    } else if (color == 2) {
                        return "#c5c52f";
                    } else if (color == 3) {
                        return "#049c04";
                    } else if (color == 4) {
                        return "#005aff";
                    } else if (color == 5) {
                        return "#ff00e0";
                    } else if (color == 6) {
                        return "#ff0000";
                    } else if (color == 7) {
                        return "#ff8c00";
                    } else {
                        return "#ff00c3e0";
                    }
                },
                  // 添加角色选中效果
                  selectChara(charaId) {
                    this.selectedCharaId = charaId;
                  },
                selectCharaList(){
                  this.$http.post("gamepassport/queryCharaList", this.formlogin,{
                    headers:{
                      'Authorization': this.getCookie("token")
                    }
                  }).then((res) => {
                      this.charaLootsList=res.data.data;
                    }
                  );
                },
                enroll(id){
                  this.selectChara(id);
                  this.setCookie("charaId", id, 3);
                  //console.log(res.data.data);
                  localStorage.setItem("charaId", id);
                  document.cookie =  document.cookie + ";charaId=" + id + ";expires=" + new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30).toUTCString() + ";path=/;"
                  this.addAccount(localStorage.getItem("username"), id)
                  //返回角色列表 进行使用或创建操作
                  this.$router.push({ name: "index" });

                  this.$router.go(0);
                },
                enroll2(id){
                  this.selectChara(id);
                  this.setCookie("charaId", id, 3);
                  //console.log(res.data.data);
                  localStorage.setItem("charaId", id);
                  document.cookie =  document.cookie + ";charaId=" + id + ";expires=" + new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30).toUTCString() + ";path=/;"
                  this.addAccount(localStorage.getItem("username"), id)
                  //返回角色列表 进行使用或创建操作
                  this.$router.push({ name: "index2" });
                  this.$router.go(0);
                },
                enroll3(id){
                  this.selectChara(id);
                  this.setCookie("charaId", id, 3);
                  //console.log(res.data.data);
                  localStorage.setItem("charaId", id);
                  document.cookie =  document.cookie + ";charaId=" + id + ";expires=" + new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30).toUTCString() + ";path=/;"
                  this.addAccount(localStorage.getItem("username"), id)
                  //返回角色列表 进行使用或创建操作
                  this.$router.push({ name: "index" });
                  this.$router.go(0);
                },
                addAccount(username, charaId) {
                  let accounts = localStorage.getItem('accounts')
                  if (accounts == null) {
                    accounts = '{}'
                  }
                  let accountObj = JSON.parse(accounts)
                  accountObj[charaId] = {
                    username,
                    charaId
                  }
                  localStorage.setItem('accounts', JSON.stringify(accountObj))
                },
                createName(){
                    this.pasEject2=true;
                    this.user = JSON.parse(sessionStorage.getItem("user"));
                    this.formRegister.userId=this.user.userId;
                },
                createName2(){
                    this.pasEject=true;
                    //this.user = JSON.parse(sessionStorage.getItem("user"));
                    this.formRegister.userId=localStorage.getItem("userId")
                    //this.formRegister.userId=this.user.userId;
                },
                reg(){
                  this.$http.post("gamepassport/createChara", this.formRegister).then((res) => {
                     if (res.data.status === 200) {
                      this.pasEject = false;
                      this.pasEject2 = false;
                     }
                    this.selectCharaList();
                    if (res.data.msg != "ok") {
                      this.$Notice.warning({title:res.data.msg});
                      return;
                    }
                  
                  });
                },
            },
        };
        </script>

<style scoped>
  /* 移动端适配样式 */
  @media (max-width: 768px) {
    .chara-select-container {
      padding: 0;
      background: #f5f5f5;
      min-height: 100vh;
    }

    .mobile-create-btn {
      padding: 15px;
      background: white;
      margin-bottom: 10px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }

    .chara-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr); /* 一行两个 */
      gap: 10px;
      padding: 10px;
    }

    .chara-card {
      background: white;
      border-radius: 12px;
      box-shadow: 0 2px 12px rgba(0,0,0,0.08);
      overflow: hidden;
      transition: all 0.3s ease;
      border: 2px solid transparent;
    }

    .chara-card:hover, .chara-card.selected {
      border-color: #2d8cf0;
      transform: translateY(-2px);
      box-shadow: 0 4px 20px rgba(45, 140, 240, 0.2);
    }

    .chara-card-content {
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .chara-avatar {
      margin-bottom: 10px;
    }

    .chara-info {
      text-align: center;
      margin-bottom: 15px;
      width: 100%;
    }

    .chara-name {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-bottom: 5px;
      word-break: break-all;
    }

    .chara-level {
      font-size: 14px;
      color: #666;
      margin-bottom: 3px;
    }

    .chara-realm {
      font-size: 12px;
      color: #2d8cf0;
      background: rgba(45, 140, 240, 0.1);
      padding: 2px 8px;
      border-radius: 10px;
      display: inline-block;
    }

    .chara-actions {
      width: 100%;
    }

    .chara-actions >>> .ivu-btn-group {
      width: 100%;
    }

    .chara-actions >>> .ivu-btn {
      margin-bottom: 5px;
    }

    .chara-actions >>> .ivu-btn:last-child {
      margin-bottom: 0;
    }

    .empty-chara-list {
      grid-column: 1 / 3;
      text-align: center;
      padding: 40px 20px;
      color: #999;
    }

    .empty-tip {
      font-size: 12px;
      color: #ccc;
      margin-top: 5px;
    }

    /* 创建角色弹窗 */
    .create-chara-modal >>> .ivu-modal {
      width: 100% !important;
      margin: 0;
      border-radius: 0;
      height: 40vh;
    }

    .create-chara-content {
      padding: 0;
    }

    .create-chara-content >>> .ivu-form {
      padding: 20px;
    }

    .spirit-option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
    }

    .spirit-name {
      font-weight: 500;
      color: #333;
    }

    .spirit-desc {
      font-size: 12px;
      color: #999;
    }

    .mobile-modal-buttons {
      padding: 20px 0;
      background: white;
      border-top: 1px solid #e8eaec;
      margin-top: 20px;
    }
  }

  /* PC端样式 */
  @media (min-width: 769px) {
    .chara-select-container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px;
    }

    .chara-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr); /* PC端一行4个 */
      gap: 20px;
    }

    .mobile-create-btn {
      display: none;
    }
  }

  /* 超小屏幕适配 */
  @media (max-width: 480px) {
    .chara-grid {
      grid-template-columns: 1fr; /* 超小屏幕一行1个 */
    }

    .empty-chara-list {
      grid-column: 1 / 2;
    }
  }

  /* 中等屏幕 */
  @media (min-width: 481px) and (max-width: 768px) {
    .chara-grid {
      grid-template-columns: repeat(2, 1fr); /* 保持一行2个 */
    }
  }
  </style>
  <style scoped>
  /* 弹窗整体样式 - 白色主题 */
.immortal-modal-light /deep/ .ivu-modal-content {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.immortal-modal-light /deep/ .ivu-modal-body {
  padding: 0;
}

/* 自定义头部 */
.modal-header-custom {
  background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
  padding: 24px 20px 20px;
  text-align: center;
}

.header-icon {
  font-size: 36px;
  margin-bottom: 8px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
}

.header-title {
  font-size: 22px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 4px;
  letter-spacing: 4px;
}

.header-subtitle {
  font-size: 12px;
  color: #95a5a6;
  letter-spacing: 2px;
}

/* 内容区域 */
.create-character-content {
  padding: 24px;
  display: flex;
  gap: 24px;
  background: #ffffff;
}

/* 角色预览 */
.character-preview {
  width: 140px;
  display: flex;
  height: 200px;
  flex-direction: column;
  align-items: center;
  padding: 20px 10px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e8e8e8;
}

.avatar-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 3px solid #e8e8e8;
  transition: all 0.3s;
}

.avatar-circle.male {
  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
  border-color: #74b9ff;
  box-shadow: 0 4px 15px rgba(116, 185, 255, 0.3);
}

.avatar-circle.female {
  background: linear-gradient(135deg, #fd79a8 0%, #e84393 100%);
  border-color: #fd79a8;
  box-shadow: 0 4px 15px rgba(253, 121, 168, 0.3);
}

.avatar-inner {
  font-size: 36px;
  color: #fff;
  font-weight: bold;
}

.spirit-glow {
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border-radius: 50%;
  border: 2px solid #FFD700;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 0.5; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.05); }
}

.preview-name {
  margin-top: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #2c3e50;
  text-align: center;
  word-break: break-all;
}

.preview-name.placeholder {
  color: #bdc3c7;
  font-weight: normal;
}

.preview-root {
  margin-top: 6px;
  font-size: 12px;
  color: #7f8c8d;
  padding: 2px 10px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
}

/* 表单区域 */
.immortal-form {
  flex: 1;
}

.input-group {
  margin-bottom: 4px;
}

.input-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #2c3e50;
  font-size: 14px;
  font-weight: 500;
}

.input-label i {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
}

.icon-ming {
  background: #fff3cd;
  color: #856404;
}

.icon-ling {
  background: #d1ecf1;
  color: #0c5460;
}

.icon-xing {
  background: #f8d7da;
  color: #721c24;
}

.input-hint {
  margin-top: 6px;
  font-size: 11px;
  color: #95a5a6;
  padding-left: 32px;
}

/* 输入框样式 */
.immortal-input /deep/ input,
.immortal-select /deep/ .ivu-select-selection {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  color: #2c3e50 !important;
  border-radius: 8px !important;
  transition: all 0.3s;
}

.immortal-input /deep/ input::placeholder {
  color: #c0c4cc !important;
}

.immortal-input /deep/ input:focus,
.immortal-select /deep/ .ivu-select-selection:focus {
  border-color: #409eff !important;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2) !important;
}

/* 下拉选项样式 */
.root-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.root-icon {
  font-size: 12px;
}

.root-desc {
  margin-left: auto;
  font-size: 11px;
  color: #909399;
}

/* 性别选择器 */
.gender-selector {
  display: flex;
  gap: 12px;
}

.gender-option {
  flex: 1;
  padding: 16px;
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  transition: all 0.3s;
}

.gender-option:hover {
  border-color: #c0c4cc;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.gender-option.active {
  border-color: #409eff;
  background: #ecf5ff;
}

.gender-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin: 0 auto 8px;
  font-weight: bold;
}

.gender-icon.male {
  background: #e3f2fd;
  color: #1976d2;
}

.gender-icon.female {
  background: #fce4ec;
  color: #c2185b;
}

.gender-text {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 500;
}

.gender-desc {
  font-size: 11px;
  color: #95a5a6;
  margin-top: 2px;
}

.face-selector {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.face-option {
  padding: 4px;
  border: 2px solid #e8e8e8;
  border-radius: 10px;
  background: #f8f9fa;
  cursor: pointer;
  transition: all 0.25s ease;
}

.face-option:hover {
  border-color: #91caff;
  transform: translateY(-1px);
}

.face-option.active {
  border-color: #409eff;
  background: #ecf5ff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
}

.face-option-img {
  display: block;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 8px;
}
/* 底部按钮 */
.modal-footer-custom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}

.btn-cancel {
  background: #ffffff !important;
  border: 1px solid #dcdfe6 !important;
  color: #606266 !important;
}

.btn-cancel:hover {
  border-color: #409eff !important;
  color: #409eff !important;
}

.btn-confirm {
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%) !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 500 !important;
  padding: 0 24px !important;
}

.btn-confirm:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4) !important;
}

.btn-confirm:disabled {
  background: #c0c4cc !important;
  color: #ffffff !important;
  cursor: not-allowed;
}

/* 下拉菜单样式覆盖 */
.immortal-modal-light /deep/ .ivu-select-dropdown {
  background: #ffffff !important;
  border: 1px solid #e4e7ed !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}

.immortal-modal-light /deep/ .ivu-select-item {
  color: #606266 !important;
}

.immortal-modal-light /deep/ .ivu-select-item:hover {
  background: #f5f7fa !important;
  color: #409eff !important;
}

.immortal-modal-light /deep/ .ivu-select-item-selected {
  background: #ecf5ff !important;
  color: #409eff !important;
}
  </style>




// WEBPACK FOOTER //
// src/components/selectChara.vue